import { CountryCodesType } from '../country-config/countries';

// TODO: Get rid of this as soon as we get rid of the session.service from the cemexcomponents repo.
export interface OldLegalEntity {
  links?: {
    // tslint:disable-next-line:trailing-comma
    self: string
  };
  legalEntityId: number;
  legalEntityTypeCode: string;
  legalEntityDesc: string;
  legalEntityType: {
    links: {
      // tslint:disable-next-line:trailing-comma
      self: string
    }
    legalEntityTypeId?: number
    legalEntityTypeCode?: string
    // tslint:disable-next-line:trailing-comma
    legalEntityTypeDesc?: string
  };
  countryCode: CountryCodesType;
  address: {
    links: {
      // tslint:disable-next-line:trailing-comma
      self: string
    }
    // tslint:disable-next-line:trailing-comma
    addressId: number
  };
}

export interface ILegalEntity extends OldLegalEntity {
  // address: Address;
  countryCode: CountryCodesType;
  legalEntityDesc: string;
  // legalEntityType: LegalEntityType;
  legalEntityId: number;
  legalEntityCode?: string;
}
